import i18n from "@/lib/i18n";

export function AutoTranslate(text: string) {
  const storedLanguage =
    typeof window !== "undefined" ? window.localStorage.getItem("language") : null;

  if (storedLanguage && i18n.language !== storedLanguage) {
    void i18n.changeLanguage(storedLanguage);
  }

  if (!i18n.exists("autoTranslate")) {
    return `failed to translate:${text}`;
  }

  const transText = i18n.t("autoTranslate", { returnObjects: true }) as Record<string, string>;
  let key = text.replace(/ /g, "");

  key = key.replace(/\n/g, "");
  key = key.replace(/:/g, "▌");
  key = key.replace(/\./g, "⌡");

  if (transText[key] === undefined) {
    return `UTR: ${text}`;
  }

  return transText[key].replace(/▒/g, " ").replace(/░/g, "\n");
}
